/**
 * Routes UTILS.
 */
let UTILS = {
  navigarion: {
    github: () => {
      window.location.replace("https://github.com/myfirebase/myfirebase")
    },
    docs: () => {
      window.location.replace("https://myfirebase.github.io")
    }
  }
}

export default UTILS;



// WEBPACK FOOTER //
// ./src/router/utils/index.js